export default "__VITE_ASSET__CZWHsrot__"